module.exports = __webpack_public_path__ + "img/07_shimizu_13.472639df.jpg";